import Analytics from "./Analytics";

const AnalyticsGoogle = {};
AnalyticsGoogle.init = () => {
	const measurementId = __ANALYTICS_CONFIG.id;

	const loadAsync = (scriptSrc, callback) => {
		if (typeof callback !== "function") {
			throw new Error("Not a valid callback for async script load");
		}
		const script = document.createElement("script");
		script.onload = callback;
		script.src = scriptSrc;
		document.head.appendChild(script);
	};

	loadAsync("https://www.googletagmanager.com/gtag/js?id=" + measurementId, function () {
		window.dataLayer = window.dataLayer || [];
		function gtag() {
            dataLayer.push(arguments); // eslint-disable-line
		}
		gtag("js", new Date());
		gtag("config", measurementId, { send_page_view: true });
		window.gtag = gtag;
		Analytics._initialised = true;

		gtag("event", "page_view");

		Analytics._log("Analytics: initialised!");

		Analytics._processEventQueue();
	});
};

AnalyticsGoogle.isInitialised = () => {
	return false;
};

AnalyticsGoogle.set = (data) => {
	Analytics._log("Analytics: set", data);
	window.gtag("set", data);
};
//
AnalyticsGoogle.event = (action, data = null) => {
	if (data !== null) {
		if (typeof data.category !== "undefined") {
			data.event_category = data.category;
		}

		// Set label as username if specified, otherwise try use normal label.
		if (typeof data.username !== "undefined") {
			data.event_label = data.username;
		}
		else if (typeof data.label !== "undefined") {
			data.event_label = data.label;
		}

		Analytics._log("Analytics: event", action, data);
		window.gtag("event", action, data);
	}
	else {
		Analytics._log("Analytics: event", action);
		window.gtag("event", action);
	}
};
export default AnalyticsGoogle;
